import * as React from "react";
import { Button, notification, Table } from "antd";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { ColumnsType } from "antd/es/table";
import { ZUid } from "src/types/zUid";
import { ModalDelete } from "src/components/ModalDelete";
import { onError } from "src/common/onError";
import { ZBom2a } from "../../Bom2aTypes";
import { Bom2aCreateModal } from "./Bom2aCreateModal";
import { bom2aStore as store } from "../Bom2aStore";
import styles from "./Bom2aSummary.module.less";

export const Bom2aSummary: React.FC = observer(() => {
  const onDelete = () => {
    const success = async () => {
      notification.success({ message: "Выполнено удаление указанных строк" });
      await store.reload();
    };
    store.doDelete().then(success).catch(onError);
  };
  return (
    <div className={styles.main}>
      <div className={styles.toolbar}>
        <div className={styles.toolbarMain} />
        <Button
          icon={<DeleteOutlined />}
          disabled={!store.canDelete}
          danger
          onClick={() => store.setMode("delete")}
        >
          Удалить
        </Button>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          onClick={() => store.beginCreate()}
          disabled={store.buzy}
        >
          Создать BOM
        </Button>
        <Bom2aCreateModal />
      </div>
      <div className={styles.tableBox}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={store.boms}
          pagination={false}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: store.selectedBomIds,
            onChange(selectedRowKeys) {
              store.setSelectedBomIds(selectedRowKeys as ZUid[]);
            },
            columnWidth: 48,
          }}
          onRow={(row) => ({
            onClick: () => store.toggleSelectedBomId(row.id),
          })}
          className={styles.rowsClickable}
        />
      </div>
      <Bom2aCreateModal />
      <ModalDelete
        open={store.mode === "delete"}
        message="Удалить выбранные строки?"
        waiting={store.buzy}
        onCancel={() => store.setMode(null)}
        onOk={onDelete}
      />
    </div>
  );
});

const columns: ColumnsType<ZBom2a> = [
  {
    key: "name",
    title: "Название",
    render: (_, { id, name }) => (
      <Button type="link" onClick={() => store.setCurTab(String(id))}>
        {name}
      </Button>
    ),
  },
];
